// Modulos reusaveis que não são API

export const ConverteSerie = (seg) => {
  switch (seg) {
    case "0-1":
      return "Mat 1";
    case "0-2":
      return "Mat 2";
    case "0-3":
      return "Pré 1";
    case "0-4":
      return "Pré 2";
    case "1-1":
      return "1º Fund I";
    case "1-2":
      return "2º Fund I";
    case "1-3":
      return "3º Fund I";
    case "1-4":
      return "4º Fund I";
    case "1-5":
      return "5º Fund I";
    case "1-6":
      return "6º Fund II";
    case "1-7":
      return "7º Fund II";
    case "1-8":
      return "8º Fund II";
    case "1-9":
      return "9º Fund II";
    case "2-1":
      return "1ª Médio";
    case "2-2":
      return "2º Médio";
    case "2-3":
      return "3ª Médio";
    default:
      return seg;
  }
};

export const ConverteSegmentoSig = (seg) => {
  switch (seg) {
    case "0-1":
      return "EI";
    case "0-2":
      return "EI";
    case "0-3":
      return "EI";
    case "0-4":
      return "EI";
    case "1-1":
      return "EF-I";
    case "1-2":
      return "EF-I";
    case "1-3":
      return "EF-I";
    case "1-4":
      return "EF-I";
    case "1-5":
      return "EF-I";
    case "1-6":
      return "EF-II";
    case "1-7":
      return "EF-II";
    case "1-8":
      return "EF-II";
    case "1-9":
      return "EF-II";
    case "2-1":
      return "EM";
    case "2-2":
      return "EM";
    case "2-3":
      return "EM";
    default:
      return seg;
  }
};

export const ordem = (seg) => {
  switch (seg) {
    case "EI":
      return "1";
    case "EF-I":
      return "2";
    case "EF-II":
      return "3";
    case "EM":
      return "4";
    default:
      return seg;
  }
};
